import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { CirclePlusIcon } from 'images'

const ShortsChromeCard = ({ ad }) => {
  const { headline, media, logo, businessName, callToAction } = ad

  return (
    <div className="google-display-card google-display-card--shorts">
      <div className="google-display-card__shorts-stage">
        <LazyLoadImage
          className="google-display-card__media"
          src={media?.url}
          alt={media?.filename}
          width={media?.width}
          height={media?.height}
          visibleByDefault
        />
        <div className="google-display-card__shorts-gradient" />
        <div className="google-display-card__shorts-overlay">
          <div className="google-display-card__shorts-brand">
            {logo?.url ? (
              <img
                className="google-display-card__logo"
                src={logo.url}
                alt={businessName}
              />
            ) : (
              <span className="google-display-card__shorts-logo-fallback" />
            )}
            <div className="google-display-card__shorts-brand-text">
              <span className="google-display-card__shorts-business-name">{businessName ? businessName : 'Business Name'}</span>
              <span className="google-display-card__shorts-sponsored">Sponsored</span>
            </div>
          </div>
          <div className="google-display-card__shorts-headline">{headline}</div>
          <button type="button" className="google-display-card__shorts-cta">
            {callToAction}
          </button>
        </div>
      </div>
      <div className="google-display-card__shorts-nav" aria-hidden="true">
        <span className="google-display-card__shorts-nav-item" />
        <span className="google-display-card__shorts-nav-item" />
        <span className="google-display-card__shorts-nav-item google-display-card__shorts-nav-item--create">
          <CirclePlusIcon width={28} height={28} />
        </span>
        <span className="google-display-card__shorts-nav-item" />
        <span className="google-display-card__shorts-nav-item" />
      </div>
    </div>
  )
}

ShortsChromeCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    callToAction: PropTypes.string,
    media: PropTypes.object,
    logo: PropTypes.object,
    businessName: PropTypes.string,
  }).isRequired,
}

export default ShortsChromeCard
